import { Thunk, thunk } from 'easy-peasy';
import { HttpStoreModel } from '../http/models/httpModel';
import { AccountLevelConfigurationController } from '../controllers/accountLevelConfigurationController';
import HttpClientWithRetry from '../http/client/HttpClientWithRetry';
import { AccountConfiguration } from '../modules/administration/accountParameter/accountParameter.types';

export type AccountLevelConfigurationStoreModel = {
  accountLevelConfiguration: AccountLevelConfigurationModel;
};

export interface AccountLevelConfigurationModel {
  addUnresponsivePeriod: Thunk<
    AccountLevelConfigurationModel,
    { unresponsiveDismissPeriod: number; unresponsiveAgedPeriod: number; accountId: string },
    void,
    HttpStoreModel,
    Promise<boolean>
  >;
  updateAccountConfiguration: Thunk<
    AccountLevelConfigurationModel,
    { accountId: string; configuration: Partial<AccountConfiguration> },
    void,
    HttpStoreModel,
    Promise<any>
  >;
}

export const accountLevelConfigurationStoreModel: AccountLevelConfigurationModel = {
  addUnresponsivePeriod: thunk(async (_actions, payload, { getStoreState }) => {
    const controller = new AccountLevelConfigurationController(getStoreState().http.client as HttpClientWithRetry);
    await controller.addUnresponsivePeriod(payload.unresponsiveDismissPeriod, payload.unresponsiveAgedPeriod, payload.accountId);
    return true;
  }),
  updateAccountConfiguration: thunk(async (_actions, payload, { getStoreState }) => {
    const controller = new AccountLevelConfigurationController(getStoreState().http.client as HttpClientWithRetry);
    return controller.updateAccountConfiguration(payload.accountId, payload.configuration);
  }),
};
